import { useEffect, useState } from "react";
import {
  evaluateSupportConsoleAccess,
  hasAuthSession,
  installApiAuthFetch,
  logoutAllSessions,
  refreshIdpSession,
  redirectToIdpLogin,
  type SupportConsoleAccess,
} from "./auth.ts";
import { INTERNAL_LOGIN_POLICY } from "../../../web-shared/loginPolicyTexts";
import { LoginPolicyBlock } from "./LoginPolicyBlock.tsx";
import Support from "./Support.tsx";

export default function App() {
  const [booting, setBooting] = useState(true);
  const [access, setAccess] = useState<SupportConsoleAccess>({ ok: false, reason: "unauthenticated" });

  useEffect(() => {
    installApiAuthFetch();
    void refreshIdpSession().then((sess) => {
      const next = evaluateSupportConsoleAccess(sess);
      setAccess(next);
      if (!next.ok && next.reason === "unauthenticated") {
        redirectToIdpLogin();
      }
      setBooting(false);
    });
    const onUnauthorized = () => redirectToIdpLogin();
    window.addEventListener("nx:unauthorized", onUnauthorized);
    return () => window.removeEventListener("nx:unauthorized", onUnauthorized);
  }, []);

  const logout = () => {
    void logoutAllSessions().then(() => redirectToIdpLogin());
  };

  if (booting) {
    return (
      <div className="nx-login-page nx-login-page--centered">
        <main className="nx-login-page__main">
          <div className="nx-login-card">
            <p className="nx-login-card__subtitle">読み込み中…</p>
            <LoginPolicyBlock policy={INTERNAL_LOGIN_POLICY} variant="internal" />
          </div>
        </main>
      </div>
    );
  }

  if (!access.ok && access.reason === "forbidden") {
    return (
      <div className="nx-login-page nx-login-page--centered">
        <main className="nx-login-page__main">
          <div className="nx-login-card">
            <p className="nx-login-card__subtitle">このコンソールは社内スタッフ専用です</p>
            <p style={{ marginTop: 8, fontSize: 14, lineHeight: 1.5, color: "var(--muted, #666)" }}>
              No.1さま・代理店アカウントではサポートコンソールを利用できません。
              お問い合わせの確認はメールまたは顧客ポータルリンクをご利用ください。
            </p>
            <p style={{ marginTop: 16 }}>
              <button type="button" onClick={logout}>
                ログアウト
              </button>
            </p>
            <LoginPolicyBlock policy={INTERNAL_LOGIN_POLICY} variant="internal" />
          </div>
        </main>
      </div>
    );
  }

  if (!hasAuthSession()) {
    return (
      <div className="nx-login-page nx-login-page--centered">
        <main className="nx-login-page__main">
          <div className="nx-login-card">
            <p className="nx-login-card__subtitle">中央ログインへリダイレクト中…</p>
            <LoginPolicyBlock policy={INTERNAL_LOGIN_POLICY} variant="internal" />
          </div>
        </main>
      </div>
    );
  }

  return <Support onLogout={logout} />;
}
